module.exports = __webpack_public_path__ + "static/media/blog-5.7406b921.jpg";